export const docsPages = {
  "v1": {
    "index": {
      "title": "\ud83e\ude93 What is Hatchet?",
      "href": "https://docs.hatchet.run/v1/index"
    },
    "quickstart": {
      "title": "Quickstart",
      "href": "https://docs.hatchet.run/v1/quickstart"
    },
    "using-coding-agents": {
      "title": "Using Coding Agents",
      "href": "https://docs.hatchet.run/v1/using-coding-agents"
    },
    "running-locally": {
      "title": "Running Hatchet Locally",
      "href": "https://docs.hatchet.run/v1/running-locally"
    },
    "embedded": {
      "title": "Embedded Mode",
      "href": "https://docs.hatchet.run/v1/embedded"
    },
    "tasks": {
      "title": "Tasks",
      "href": "https://docs.hatchet.run/v1/tasks"
    },
    "workers": {
      "title": "Workers",
      "href": "https://docs.hatchet.run/v1/workers"
    },
    "running-your-task": {
      "title": "Running Tasks",
      "href": "https://docs.hatchet.run/v1/running-your-task"
    },
    "durable-execution": {
      "title": "Durable Execution",
      "href": "https://docs.hatchet.run/v1/durable-execution"
    },
    "scheduled-runs": {
      "title": "Scheduled Runs",
      "href": "https://docs.hatchet.run/v1/scheduled-runs"
    },
    "cron-runs": {
      "title": "Cron Runs",
      "href": "https://docs.hatchet.run/v1/cron-runs"
    },
    "bulk-run": {
      "title": "Bulk Triggering",
      "href": "https://docs.hatchet.run/v1/bulk-run"
    },
    "events": {
      "title": "Events",
      "href": "https://docs.hatchet.run/v1/events"
    },
    "webhooks": {
      "title": "Webhooks",
      "href": "https://docs.hatchet.run/v1/webhooks"
    },
    "inter-service-triggering": {
      "title": "Inter-Service Triggering",
      "href": "https://docs.hatchet.run/v1/inter-service-triggering"
    },
    "retry-policies": {
      "title": "Retry Policies",
      "href": "https://docs.hatchet.run/v1/retry-policies"
    },
    "timeouts": {
      "title": "Timeouts",
      "href": "https://docs.hatchet.run/v1/timeouts"
    },
    "cancellation": {
      "title": "Cancellation",
      "href": "https://docs.hatchet.run/v1/cancellation"
    },
    "pausing-workflows": {
      "title": "Pausing Workflows",
      "href": "https://docs.hatchet.run/v1/pausing-workflows"
    },
    "bulk-retries-and-cancellations": {
      "title": "Bulk Retries & Cancellations",
      "href": "https://docs.hatchet.run/v1/bulk-retries-and-cancellations"
    },
    "concurrency": {
      "title": "Concurrency",
      "href": "https://docs.hatchet.run/v1/concurrency"
    },
    "rate-limits": {
      "title": "Rate Limits",
      "href": "https://docs.hatchet.run/v1/rate-limits"
    },
    "priority": {
      "title": "Priority",
      "href": "https://docs.hatchet.run/v1/priority"
    },
    "idempotency": {
      "title": "Idempotency",
      "href": "https://docs.hatchet.run/v1/idempotency"
    },
    "batch-tasks": {
      "title": "Batch Tasks",
      "href": "https://docs.hatchet.run/v1/batch-tasks"
    },
    "cel-expressions": {
      "title": "CEL Expressions",
      "href": "https://docs.hatchet.run/v1/cel-expressions"
    },
    "durable-tasks": {
      "title": "Durable Tasks",
      "href": "https://docs.hatchet.run/v1/durable-tasks"
    },
    "child-spawning": {
      "title": "Child Spawning",
      "href": "https://docs.hatchet.run/v1/child-spawning"
    },
    "durable-sleep": {
      "title": "Sleeps",
      "href": "https://docs.hatchet.run/v1/durable-sleep"
    },
    "durable-event-waits": {
      "title": "Event Waits",
      "href": "https://docs.hatchet.run/v1/durable-event-waits"
    },
    "task-eviction": {
      "title": "Task Eviction",
      "href": "https://docs.hatchet.run/v1/task-eviction"
    },
    "directed-acyclic-graphs": {
      "title": "DAGs as Durable Workflows",
      "href": "https://docs.hatchet.run/v1/directed-acyclic-graphs"
    },
    "docker": {
      "title": "Running with Docker",
      "href": "https://docs.hatchet.run/v1/docker"
    },
    "autoscaling-workers": {
      "title": "Autoscaling Workers",
      "href": "https://docs.hatchet.run/v1/autoscaling-workers"
    },
    "advanced-assignment": {
      "sticky-assignment": {
        "title": "Sticky Assignment",
        "href": "https://docs.hatchet.run/v1/advanced-assignment/sticky-assignment"
      },
      "worker-affinity": {
        "title": "Worker Affinity",
        "href": "https://docs.hatchet.run/v1/advanced-assignment/worker-affinity"
      },
      "slot-cost": {
        "title": "Task Slot Cost",
        "href": "https://docs.hatchet.run/v1/advanced-assignment/slot-cost"
      },
      "manual-slot-release": {
        "title": "Manual Slot Release",
        "href": "https://docs.hatchet.run/v1/advanced-assignment/manual-slot-release"
      },
      "index": {
        "title": "Advanced Assignment",
        "href": "https://docs.hatchet.run/v1/advanced-assignment/index"
      },
      "title": "Advanced Assignment",
      "href": "https://docs.hatchet.run/v1/advanced-assignment"
    },
    "logging": {
      "title": "Logging",
      "href": "https://docs.hatchet.run/v1/logging"
    },
    "opentelemetry": {
      "title": "OpenTelemetry",
      "href": "https://docs.hatchet.run/v1/opentelemetry"
    },
    "worker-healthchecks": {
      "title": "Worker Health Checks",
      "href": "https://docs.hatchet.run/v1/worker-healthchecks"
    },
    "prometheus-metrics": {
      "title": "Prometheus Metrics",
      "href": "https://docs.hatchet.run/v1/prometheus-metrics"
    },
    "additional-metadata": {
      "title": "Additional Metadata",
      "href": "https://docs.hatchet.run/v1/additional-metadata"
    },
    "middleware": {
      "title": "Middleware",
      "href": "https://docs.hatchet.run/v1/middleware"
    },
    "durable-streams": {
      "title": "Durable Streams",
      "href": "https://docs.hatchet.run/v1/durable-streams"
    },
    "environments": {
      "title": "Environments",
      "href": "https://docs.hatchet.run/v1/environments"
    },
    "api-tokens": {
      "title": "API Tokens",
      "href": "https://docs.hatchet.run/v1/api-tokens"
    },
    "troubleshooting": {
      "index": {
        "title": "Troubleshooting Workers",
        "href": "https://docs.hatchet.run/v1/troubleshooting/index"
      },
      "title": "Troubleshooting",
      "href": "https://docs.hatchet.run/v1/troubleshooting"
    },
    "single-sign-on": {
      "title": "SSO",
      "href": "https://docs.hatchet.run/v1/single-sign-on"
    },
    "user-roles": {
      "title": "User Roles",
      "href": "https://docs.hatchet.run/v1/user-roles"
    },
    "user-groups": {
      "title": "User Groups",
      "href": "https://docs.hatchet.run/v1/user-groups"
    },
    "architecture-and-guarantees": {
      "title": "Architecture & Guarantees",
      "href": "https://docs.hatchet.run/v1/architecture-and-guarantees"
    },
    "cloud-vs-oss": {
      "title": "Cloud vs OSS",
      "href": "https://docs.hatchet.run/v1/cloud-vs-oss"
    },
    "security": {
      "index": {
        "title": "About",
        "href": "https://docs.hatchet.run/v1/security/index"
      },
      "audit-logs": {
        "title": "Audit Logs",
        "href": "https://docs.hatchet.run/v1/security/audit-logs"
      },
      "title": "Security",
      "href": "https://docs.hatchet.run/v1/security"
    },
    "region-availability": {
      "title": "Region Availability",
      "href": "https://docs.hatchet.run/v1/region-availability"
    },
    "uptime": {
      "title": "Uptime",
      "href": "https://docs.hatchet.run/v1/uptime"
    },
    "developer-experience": {
      "title": "Developer Experience",
      "href": "https://docs.hatchet.run/v1/developer-experience"
    },
    "from-celery-to-hatchet": {
      "title": "From Celery to Hatchet",
      "href": "https://docs.hatchet.run/v1/from-celery-to-hatchet"
    },
    "from-temporal-to-hatchet": {
      "title": "From Temporal to Hatchet",
      "href": "https://docs.hatchet.run/v1/from-temporal-to-hatchet"
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "href": "https://docs.hatchet.run/v1/faq"
    },
    "compute": {
      "index": {
        "title": "Overview",
        "href": "https://docs.hatchet.run/v1/compute/index"
      },
      "getting-started": {
        "title": "Getting Started",
        "href": "https://docs.hatchet.run/v1/compute/getting-started"
      },
      "cpu": {
        "title": "CPU Machine Types",
        "href": "https://docs.hatchet.run/v1/compute/cpu"
      },
      "gpu": {
        "title": "GPU Machine Types",
        "href": "https://docs.hatchet.run/v1/compute/gpu"
      },
      "git-ops": {
        "title": "GitOps",
        "href": "https://docs.hatchet.run/v1/compute/git-ops"
      },
      "auto-scaling": {
        "title": "Auto Scaling",
        "href": "https://docs.hatchet.run/v1/compute/auto-scaling"
      },
      "environment-variables": {
        "title": "Environment Variables",
        "href": "https://docs.hatchet.run/v1/compute/environment-variables"
      },
      "title": "Managed Compute",
      "href": "https://docs.hatchet.run/v1/compute"
    },
    "error-handling": {
      "index": {
        "title": "Reliability",
        "href": "https://docs.hatchet.run/v1/error-handling/index"
      },
      "title": "Reliability",
      "href": "https://docs.hatchet.run/v1/error-handling"
    },
    "migrating": {
      "v1-sdk-improvements": {
        "title": "SDK Improvements",
        "href": "https://docs.hatchet.run/v1/migrating/v1-sdk-improvements"
      },
      "migration-guide-engine": {
        "title": "Engine Migration Guide",
        "href": "https://docs.hatchet.run/v1/migrating/migration-guide-engine"
      },
      "migration-guide-python": {
        "title": "Python Migration Guide",
        "href": "https://docs.hatchet.run/v1/migrating/migration-guide-python"
      },
      "migration-guide-typescript": {
        "title": "Typescript Migration Guide",
        "href": "https://docs.hatchet.run/v1/migrating/migration-guide-typescript"
      },
      "migration-guide-go": {
        "title": "Go Migration Guide",
        "href": "https://docs.hatchet.run/v1/migrating/migration-guide-go"
      },
      "title": "V0 to V1 Upgrade Guide",
      "href": "https://docs.hatchet.run/v1/migrating"
    },
    "serverless": {
      "cloudflare-workers": {
        "title": "Cloudflare Workers",
        "href": "https://docs.hatchet.run/v1/serverless/cloudflare-workers"
      },
      "vercel": {
        "title": "Vercel",
        "href": "https://docs.hatchet.run/v1/serverless/vercel"
      },
      "http": {
        "title": "HTTP Contract",
        "href": "https://docs.hatchet.run/v1/serverless/http"
      },
      "managing-endpoints": {
        "title": "Managing Endpoints",
        "href": "https://docs.hatchet.run/v1/serverless/managing-endpoints"
      },
      "troubleshooting": {
        "title": "Troubleshooting",
        "href": "https://docs.hatchet.run/v1/serverless/troubleshooting"
      },
      "index": {
        "title": "Serverless Endpoints",
        "href": "https://docs.hatchet.run/v1/serverless/index"
      },
      "title": "Serverless Endpoints",
      "href": "https://docs.hatchet.run/v1/serverless"
    },
    "streaming": {
      "title": "Streaming",
      "href": "https://docs.hatchet.run/v1/streaming"
    },
    "title": "Guide",
    "href": "https://docs.hatchet.run/v1"
  },
  "cookbooks": {
    "index": {
      "title": "Overview",
      "href": "https://docs.hatchet.run/cookbooks/index"
    },
    "webhooks-stripe": {
      "title": "Stripe",
      "href": "https://docs.hatchet.run/cookbooks/webhooks-stripe"
    },
    "webhooks-github": {
      "title": "GitHub",
      "href": "https://docs.hatchet.run/cookbooks/webhooks-github"
    },
    "webhooks-slack": {
      "title": "Slack",
      "href": "https://docs.hatchet.run/cookbooks/webhooks-slack"
    },
    "workflow-support-agent": {
      "title": "Support Agent",
      "href": "https://docs.hatchet.run/cookbooks/workflow-support-agent"
    },
    "welcome-email": {
      "title": "Welcome Email",
      "href": "https://docs.hatchet.run/cookbooks/welcome-email"
    },
    "durable-tasks-vs-dags": {
      "title": "Durable Tasks vs DAGs",
      "href": "https://docs.hatchet.run/cookbooks/durable-tasks-vs-dags"
    },
    "pdf-pipeline": {
      "title": "PDF Pipeline",
      "href": "https://docs.hatchet.run/cookbooks/pdf-pipeline"
    },
    "workflow-aws-s3": {
      "title": "S3 Processing Pipeline",
      "href": "https://docs.hatchet.run/cookbooks/workflow-aws-s3"
    },
    "hatchet-and-mcp": {
      "title": "Hatchet Agent Tools",
      "href": "https://docs.hatchet.run/cookbooks/hatchet-and-mcp"
    },
    "hatchet-claude-agent-sdk-trusted-env": {
      "title": "Claude Agent SDK",
      "href": "https://docs.hatchet.run/cookbooks/hatchet-claude-agent-sdk-trusted-env"
    },
    "hatchet-openai-agents-sdk-trusted-env": {
      "title": "OpenAI Agents SDK",
      "href": "https://docs.hatchet.run/cookbooks/hatchet-openai-agents-sdk-trusted-env"
    },
    "title": "Cookbooks",
    "href": "https://docs.hatchet.run/cookbooks"
  },
  "self-hosting": {
    "index": {
      "title": "Introduction",
      "href": "https://docs.hatchet.run/self-hosting/index"
    },
    "hatchet-lite": {
      "title": "Hatchet Lite",
      "href": "https://docs.hatchet.run/self-hosting/hatchet-lite"
    },
    "docker-compose": {
      "title": "Docker Compose",
      "href": "https://docs.hatchet.run/self-hosting/docker-compose"
    },
    "kubernetes-quickstart": {
      "title": "Quickstart",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-quickstart"
    },
    "networking": {
      "title": "Networking",
      "href": "https://docs.hatchet.run/self-hosting/networking"
    },
    "kubernetes-helm-configuration": {
      "title": "Configuring the Helm Chart",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-helm-configuration"
    },
    "kubernetes-external-database": {
      "title": "Setting up an External Database",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-external-database"
    },
    "high-availability": {
      "title": "High Availability",
      "href": "https://docs.hatchet.run/self-hosting/high-availability"
    },
    "configuration-options": {
      "title": "Engine Configuration Options",
      "href": "https://docs.hatchet.run/self-hosting/configuration-options"
    },
    "using-pgbouncer": {
      "title": "Using PgBouncer",
      "href": "https://docs.hatchet.run/self-hosting/using-pgbouncer"
    },
    "prometheus-metrics": {
      "title": "Prometheus Metrics",
      "href": "https://docs.hatchet.run/self-hosting/prometheus-metrics"
    },
    "opentelemetry": {
      "title": "Internal OpenTelemetry Traces",
      "href": "https://docs.hatchet.run/self-hosting/opentelemetry"
    },
    "worker-configuration-options": {
      "title": "Worker Configuration Options",
      "href": "https://docs.hatchet.run/self-hosting/worker-configuration-options"
    },
    "upgrading-downgrading": {
      "title": "Upgrading and Downgrading",
      "href": "https://docs.hatchet.run/self-hosting/upgrading-downgrading"
    },
    "downgrading-db-schema-manually": {
      "title": "Downgrading DB Schema Manually",
      "href": "https://docs.hatchet.run/self-hosting/downgrading-db-schema-manually"
    },
    "benchmarking": {
      "title": "Benchmarking",
      "href": "https://docs.hatchet.run/self-hosting/benchmarking"
    },
    "data-retention": {
      "title": "Data Retention",
      "href": "https://docs.hatchet.run/self-hosting/data-retention"
    },
    "improving-performance": {
      "title": "Improving Performance",
      "href": "https://docs.hatchet.run/self-hosting/improving-performance"
    },
    "read-replicas": {
      "title": "Read Replicas",
      "href": "https://docs.hatchet.run/self-hosting/read-replicas"
    },
    "sampling": {
      "title": "Trace Sampling",
      "href": "https://docs.hatchet.run/self-hosting/sampling"
    },
    "smtp-server": {
      "title": "SMTP Server",
      "href": "https://docs.hatchet.run/self-hosting/smtp-server"
    },
    "fips": {
      "title": "FIPS 140-3 Images",
      "href": "https://docs.hatchet.run/self-hosting/fips"
    },
    "title": "Self-Hosting",
    "href": "https://docs.hatchet.run/self-hosting"
  },
  "reference": {
    "index": {
      "title": "Reference",
      "href": "https://docs.hatchet.run/reference/index"
    },
    "changelog": {
      "index": {
        "title": "Overview",
        "href": "https://docs.hatchet.run/reference/changelog/index"
      },
      "platform": {
        "title": "Platform & Go SDK",
        "href": "https://docs.hatchet.run/reference/changelog/platform"
      },
      "python": {
        "title": "Python SDK",
        "href": "https://docs.hatchet.run/reference/changelog/python"
      },
      "typescript": {
        "title": "TypeScript SDK",
        "href": "https://docs.hatchet.run/reference/changelog/typescript"
      },
      "ruby": {
        "title": "Ruby SDK",
        "href": "https://docs.hatchet.run/reference/changelog/ruby"
      },
      "title": "Changelog",
      "href": "https://docs.hatchet.run/reference/changelog"
    },
    "python": {
      "index": {
        "title": "Overview",
        "href": "https://docs.hatchet.run/reference/python/index"
      },
      "client": {
        "title": "Client",
        "href": "https://docs.hatchet.run/reference/python/client"
      },
      "context": {
        "title": "Context",
        "href": "https://docs.hatchet.run/reference/python/context"
      },
      "feature-clients": {
        "cel": {
          "title": "CEL",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/cel"
        },
        "cron": {
          "title": "Cron",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/cron"
        },
        "filters": {
          "title": "Filters",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/filters"
        },
        "logs": {
          "title": "Logs",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/logs"
        },
        "metrics": {
          "title": "Metrics",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/metrics"
        },
        "rate_limits": {
          "title": "Rate Limits",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/rate_limits"
        },
        "runs": {
          "title": "Runs",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/runs"
        },
        "scheduled": {
          "title": "Scheduled",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/scheduled"
        },
        "streams": {
          "title": "Streams",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/streams"
        },
        "stubs": {
          "title": "Stubs",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/stubs"
        },
        "webhooks": {
          "title": "Webhooks",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/webhooks"
        },
        "workers": {
          "title": "Workers",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/workers"
        },
        "workflows": {
          "title": "Workflows",
          "href": "https://docs.hatchet.run/reference/python/feature-clients/workflows"
        },
        "title": "Feature Clients",
        "href": "https://docs.hatchet.run/reference/python/feature-clients"
      },
      "runnables": {
        "title": "Runnables",
        "href": "https://docs.hatchet.run/reference/python/runnables"
      },
      "asyncio": {
        "title": "Asyncio",
        "href": "https://docs.hatchet.run/reference/python/asyncio"
      },
      "pydantic": {
        "title": "Pydantic",
        "href": "https://docs.hatchet.run/reference/python/pydantic"
      },
      "lifespans": {
        "title": "Lifespans",
        "href": "https://docs.hatchet.run/reference/python/lifespans"
      },
      "dependency-injection": {
        "title": "Dependency Injection",
        "href": "https://docs.hatchet.run/reference/python/dependency-injection"
      },
      "dataclasses": {
        "title": "Dataclass Support",
        "href": "https://docs.hatchet.run/reference/python/dataclasses"
      },
      "title": "Python SDK",
      "href": "https://docs.hatchet.run/reference/python"
    },
    "typescript": {
      "index": {
        "title": "Overview",
        "href": "https://docs.hatchet.run/reference/typescript/index"
      },
      "client": {
        "title": "Client",
        "href": "https://docs.hatchet.run/reference/typescript/client"
      },
      "context": {
        "title": "Context",
        "href": "https://docs.hatchet.run/reference/typescript/context"
      },
      "embedded": {
        "title": "Embedded",
        "href": "https://docs.hatchet.run/reference/typescript/embedded"
      },
      "feature-clients": {
        "cel": {
          "title": "CEL",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/cel"
        },
        "crons": {
          "title": "Crons",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/crons"
        },
        "filters": {
          "title": "Filters",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/filters"
        },
        "logs": {
          "title": "Logs",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/logs"
        },
        "metrics": {
          "title": "Metrics",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/metrics"
        },
        "ratelimits": {
          "title": "Ratelimits",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/ratelimits"
        },
        "runs": {
          "title": "Runs",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/runs"
        },
        "schedules": {
          "title": "Schedules",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/schedules"
        },
        "streams": {
          "title": "Streams",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/streams"
        },
        "tenant": {
          "title": "Tenant",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/tenant"
        },
        "webhooks": {
          "title": "Webhooks",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/webhooks"
        },
        "workers": {
          "title": "Workers",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/workers"
        },
        "workflows": {
          "title": "Workflows",
          "href": "https://docs.hatchet.run/reference/typescript/feature-clients/workflows"
        },
        "title": "Feature Clients",
        "href": "https://docs.hatchet.run/reference/typescript/feature-clients"
      },
      "runnables": {
        "title": "Runnables",
        "href": "https://docs.hatchet.run/reference/typescript/runnables"
      },
      "title": "TypeScript SDK",
      "href": "https://docs.hatchet.run/reference/typescript"
    },
    "go": {
      "index": {
        "title": "Overview",
        "href": "https://docs.hatchet.run/reference/go/index"
      },
      "client": {
        "title": "Client",
        "href": "https://docs.hatchet.run/reference/go/client"
      },
      "context": {
        "title": "Context",
        "href": "https://docs.hatchet.run/reference/go/context"
      },
      "embedded": {
        "title": "Embedded",
        "href": "https://docs.hatchet.run/reference/go/embedded"
      },
      "feature-clients": {
        "cel": {
          "title": "CEL",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/cel"
        },
        "crons": {
          "title": "Crons",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/crons"
        },
        "filters": {
          "title": "Filters",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/filters"
        },
        "logs": {
          "title": "Logs",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/logs"
        },
        "metrics": {
          "title": "Metrics",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/metrics"
        },
        "ratelimits": {
          "title": "Rate Limits",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/ratelimits"
        },
        "runs": {
          "title": "Runs",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/runs"
        },
        "schedules": {
          "title": "Schedules",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/schedules"
        },
        "streams": {
          "title": "Streams",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/streams"
        },
        "webhooks": {
          "title": "Webhooks",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/webhooks"
        },
        "workers": {
          "title": "Workers",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/workers"
        },
        "workflows": {
          "title": "Workflows",
          "href": "https://docs.hatchet.run/reference/go/feature-clients/workflows"
        },
        "title": "Feature Clients",
        "href": "https://docs.hatchet.run/reference/go/feature-clients"
      },
      "runnables": {
        "title": "Runnables",
        "href": "https://docs.hatchet.run/reference/go/runnables"
      },
      "title": "Go SDK",
      "href": "https://docs.hatchet.run/reference/go"
    },
    "ruby": {
      "index": {
        "title": "Overview",
        "href": "https://docs.hatchet.run/reference/ruby/index"
      },
      "client": {
        "title": "Client",
        "href": "https://docs.hatchet.run/reference/ruby/client"
      },
      "context": {
        "title": "Context",
        "href": "https://docs.hatchet.run/reference/ruby/context"
      },
      "feature-clients": {
        "cel": {
          "title": "CEL",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/cel"
        },
        "cron": {
          "title": "Cron",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/cron"
        },
        "events": {
          "title": "Events",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/events"
        },
        "filters": {
          "title": "Filters",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/filters"
        },
        "logs": {
          "title": "Logs",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/logs"
        },
        "metrics": {
          "title": "Metrics",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/metrics"
        },
        "rate_limits": {
          "title": "Rate Limits",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/rate_limits"
        },
        "runs": {
          "title": "Runs",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/runs"
        },
        "scheduled": {
          "title": "Scheduled",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/scheduled"
        },
        "streams": {
          "title": "Streams",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/streams"
        },
        "tenant": {
          "title": "Tenant",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/tenant"
        },
        "workers": {
          "title": "Workers",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/workers"
        },
        "workflows": {
          "title": "Workflows",
          "href": "https://docs.hatchet.run/reference/ruby/feature-clients/workflows"
        },
        "title": "Feature Clients",
        "href": "https://docs.hatchet.run/reference/ruby/feature-clients"
      },
      "runnables": {
        "title": "Runnables",
        "href": "https://docs.hatchet.run/reference/ruby/runnables"
      },
      "title": "Ruby SDK",
      "href": "https://docs.hatchet.run/reference/ruby"
    },
    "cli": {
      "index": {
        "title": "Setup & Installation",
        "href": "https://docs.hatchet.run/reference/cli/index"
      },
      "profiles": {
        "title": "Profiles",
        "href": "https://docs.hatchet.run/reference/cli/profiles"
      },
      "running-hatchet-locally": {
        "title": "Running Hatchet Locally",
        "href": "https://docs.hatchet.run/reference/cli/running-hatchet-locally"
      },
      "quickstarts": {
        "title": "Generating Quickstart Projects",
        "href": "https://docs.hatchet.run/reference/cli/quickstarts"
      },
      "running-workers-locally": {
        "title": "Running Workers Locally",
        "href": "https://docs.hatchet.run/reference/cli/running-workers-locally"
      },
      "triggering-workflows": {
        "title": "Triggering Workflows",
        "href": "https://docs.hatchet.run/reference/cli/triggering-workflows"
      },
      "mcp": {
        "title": "MCP Server",
        "href": "https://docs.hatchet.run/reference/cli/mcp"
      },
      "tui": {
        "title": "Using the Hatchet TUI",
        "href": "https://docs.hatchet.run/reference/cli/tui"
      },
      "title": "CLI Reference",
      "href": "https://docs.hatchet.run/reference/cli"
    },
    "title": "Reference",
    "href": "https://docs.hatchet.run/reference"
  },
  "contributing": {
    "index": {
      "title": "Contributing",
      "href": "https://docs.hatchet.run/contributing/index"
    },
    "github-app-setup": {
      "title": "GitHub App Setup",
      "href": "https://docs.hatchet.run/contributing/github-app-setup"
    },
    "sdks": {
      "title": "SDKs",
      "href": "https://docs.hatchet.run/contributing/sdks"
    },
    "title": "Contributing",
    "href": "https://docs.hatchet.run/contributing"
  },
  "agent-instructions": {
    "setup-cli": {
      "title": "Setup CLI",
      "href": "https://docs.hatchet.run/agent-instructions/setup-cli"
    },
    "local-dev-embedded": {
      "title": "Local Dev (Embedded)",
      "href": "https://docs.hatchet.run/agent-instructions/local-dev-embedded"
    },
    "start-worker": {
      "title": "Start Worker",
      "href": "https://docs.hatchet.run/agent-instructions/start-worker"
    },
    "trigger-and-watch": {
      "title": "Trigger & Watch",
      "href": "https://docs.hatchet.run/agent-instructions/trigger-and-watch"
    },
    "debug-run": {
      "title": "Debug a Run",
      "href": "https://docs.hatchet.run/agent-instructions/debug-run"
    },
    "replay-run": {
      "title": "Replay a Run",
      "href": "https://docs.hatchet.run/agent-instructions/replay-run"
    },
    "title": "Agent Instructions",
    "href": "https://docs.hatchet.run/agent-instructions"
  }
} as const;
